import { NgModule } from '@angular/core';

import { EventSeverityDisplayComponent } from './event-severity-display.component';

@NgModule({
  imports: [EventSeverityDisplayComponent],
  exports: [EventSeverityDisplayComponent]
})
export class EventSeverityDisplayModule {}
